import script from "./StudentRiskDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentRiskDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentRiskDialog.vue?vue&type=style&index=0&id=b9a99fd0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9a99fd0"]])

export default __exports__